import { readCheckedRating } from '../../field-viewer/prehydration-readers';
import { acceptRatingValue } from '../../field-viewer/shared-normalizers';
export const dextRatingInputViewer = {
    normalizeLoadedValue: acceptRatingValue,
    readPrehydrationValue: readCheckedRating
};

//# sourceMappingURL=definition-viewer.js.map